module.exports = __webpack_public_path__ + "img/containerFrontRight.771950e4.svg";